<template>
  <div class="home">
    <div class="header">
      <div class="header-left">
        <div class="header-left-logo">
          <LogoSvg class="svgLogo" />
        </div>
        <!-- <div class="header-left-meau">
          <div class="meau-name">File Accessa</div>
          <div class="meau-list">
            <div class="meau-item">Technical File</div>
            <div class="meau-item">File Accessa</div>
          </div>
        </div> -->
      </div>
      <div class="header-right">
        <!-- <div class="header-right-button" @click="showTips = true">
          <svg-icon icon-class="question" class-name="sidebar-logo" />
        </div> -->
        <div class="header-right-button" @click="showTips = true">
          <svg-icon icon-class="chat" class-name="sidebar-logo" />
        </div>
        <div class="header-right-button" @click="showLanguage = true">
          <img :src="language[$i18n.locale]" alt />
        </div>
      </div>
    </div>
    <div class="banner">
      <swiper
        :pagination="{ clickable: true }"
        class="swiper-no-swiping"
        :options="swiperOption"
        ref="mySwiper"
      >
        <swiper-slide>
          <div class="loop-body">
            <div class="loop-essay">
              <div class="loop-essay-title">{{ $t("banner.list")[0].title1 }}</div>
              <div class="loop-essay-title">{{ $t("banner.list")[0].title2 }}</div>

              <div class="loop-essay-content">
                <p>{{ $t("banner.list")[0].essay }}</p>
              </div>
              <div @click="showError = true" class="loop-essay-button">
                <svg-icon icon-class="mobile" class-name="sidebar-logo" />
                <span class="button-text">{{ $t(`banner.list`)[0].btn }}</span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="main">
      <!-- <div class="main-title">{{ $t("introduce.title") }}</div>
      <div class="main-news">
        <div class="main-news-img">
          <img src="@/assets/news.png" alt="" />
        </div>
        <div class="main-news-essay">
          {{ $t("introduce.essay") }}
        </div>
      </div>-->
      <div class="main-title">{{ $t("partner.title") }}</div>
      <div class="main-loop">
        <div class="main-loop-out-1">
          <div class="main-loop-out-2">
            <swiper :options="mainSwiperOption" ref="mySwiper">
              <swiper-slide>
                <div class="loop-body">
                  <img src="@/assets/main-loop-1.jpg" alt />
                  <p class="loop-body-tips">Epic of Tia</p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="loop-body">
                  <img src="@/assets/main-loop-2.jpg" alt />
                  <p class="loop-body-tips">Epic of Tia</p>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="loop-body">
                  <img src="@/assets/main-loop-3.jpg" alt />
                  <p class="loop-body-tips">Epic of Tia</p>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>

        <div class="swiper-pagination swiper-pagination-main" slot="pagination"></div>
      </div>
    </div>
    <!-- <div class="main-bottom">
      <div class="main-form">
        <div class="main-form-essay">
          <div class="main-form-essay-title">
            <p>{{ $t("contact.title") }}</p>
          </div>
          <div class="main-form-essay-content">
            {{ $t("contact.essay") }}
          </div>
          <div class="main-form-essay-tips">
            {{ $t("contact.hint") }}
          </div>
        </div>
        <div ref="formBody" class="main-form-content">
          <div class="main-form-content-title">{{ $t("contact.form.title") }}</div>
          <div class="main-form-content-tips">
            {{ $t("contact.form.hint") }}
          </div>
          <Form ref="form">
            <WInput
              class="main-form-content-input"
              name="first_name"
              ref="formItem"
              :rules="[
                {
                  rule: /[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                  errorText: $t('contact.input')[0].error,
                },
              ]"
              :placeholder="$t('contact.input')[0].placeholder"
              :error-text="$t('contact.input')[0].error"
              v-model="form.email"
              required
            />
            <WInput
              class="main-form-content-input"
              name="first_name"
              ref="formItem"
              :placeholder="$t('contact.input')[1].placeholder"
              :error-text="$t('contact.input')[1].error"
              v-model="form.company"
              required
            />
          </Form>
          <div class="main-form-content-button">
            <button @click="savaForm">{{ $t("contact.form.button") }}</button>
          </div>
        </div>
      </div>
    </div>-->
    <div class="footer">
      <LogoSvg class="svgLogo" />
      <div class="tips">
        <p>Copyright @ 2023 GearUP</p>
      </div>
    </div>
    <modal-tips @close="showTips = false" :show="showTips">
      <template>
        <p>{{ $t("contactSupport.content")[0] }}</p>
        <p>{{ $t("contactSupport.content")[1] }}</p>
      </template>
    </modal-tips>
    <modal-tips @close="showError = false" :show="showError">
      <p>{{ $t("contactSupport.download_tips") }}</p>
    </modal-tips>

    <modal-language @close="showLanguage = false" :show="showLanguage" />
    <modal-contact
      :baseFormData="form"
      @close="showContact = false"
      @finsh="sendform"
      :show="showContact"
    />
  </div>
</template>

<script>
import LogoSvg from "@/components/LogoSvg.vue";
import ModalTips from "@/components/ModalTips/index.desktop";
import ModalLanguage from "@/components/ModalForm/index.desktop";
import ModalContact from "@/components/ModalContact/index.desktop";
// import Form from "@/components/Form";
// import * as swiperAni from "../../assets/animate.js"; // 根据自己的路径进行引入
// import WInput from "@/components/Input/index.desktop";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
// import "swiper/css/pagination";
import jajp from "@/assets/img_Japan.png";
import usa from "@/assets/img_usa.png";

export default {
  name: "App",
  data() {
    return {
      showError: false,
      language: {
        "ja-jp": jajp,
        "en-us": usa,
      },
      errorEmail: false,
      errorCompany: false,
      form: {
        email: "",
        company: "",
      },
      showTips: false,
      showLanguage: false,
      showContact: false,
      swiperOption: {
        loop: true,
        observer: true,
        // noSwiper: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
        on: {},
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // on: {
        //   // 监听页面窗口变化 ---------------重要代码！
        //   resize: () => {
        //     setTimeout(() => {
        //       const swiper = this.$refs.mySwiper;

        //       // debugger;
        //       swiper.updateSwiper();
        //     }, 500); // 延时器很重要，不加可能会出错
        //   }
        // }
        // 显示分页
      },
      mainSwiperOption: {
        slidesPerView: 3,
        // spaceBetween: -20,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination-main",
          clickable: true,
        },
        // observer: true,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
      },
      // 轮播图
      banner: [
        {
          id: 1,
          img: require("@/assets/loop-1-min.png"),
        },
      ],
    };
  },
  components: {
    // Form,
    // WInput,
    Swiper,
    ModalContact,
    ModalLanguage,
    ModalTips,
    SwiperSlide,
    LogoSvg,
  },
  methods: {
    sendform(data) {},
    savaForm() {
      const result = this.$refs.form.submit();
      if (result) {
        this.showContact = true;
      }
    },
    goToForm() {
      this.$refs.formBody.scrollIntoView({ behavior: "smooth" });
    },
    onSwiper() {},
    onSlideChange() {},
  },
};
</script>

<style lang="scss" scoped>
@function pxToVWForSmall($px) {
  @return ($px/375) * 100 + vw;
}
@function pxToVWForMiddle($px) {
  @return ($px/768) * 100 + vw;
}
.home {
  .header {
    height: 80px;
    background: #282828;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 34px 0 52px;
    @include ipad(
      (
        height: 48,
        padding-left: 16,
        padding-right: 36,
      )
    );
    @include phone(
      (
        height: 48,
        padding-left: 24,
        padding-right: 16,
      )
    );
    &-left {
      display: flex;
      align-items: center;
      &-meau {
        font-weight: 700;
        font-size: 14px;
        line-height: 80px;
        flex-shrink: 0;
        position: relative;
        margin-left: 64px;
        @include ipad(
          (
            line-height: 48,
          )
        );
        @include phone(
          (
            margin-left: 14,
            height: 48,
            line-height: 48,
          )
        );
        &::before {
          content: " ";
          position: absolute;
          top: 0px;
          left: 50%;
          width: 47px;
          height: 6px;
          background: #ffd591;
          margin-left: -24px;
        }
        cursor: pointer;
        text-transform: capitalize;
        color: #ffd591;

        .meau-list {
          transition: all 2s;
          text-indent: 15px;
          width: 142px;
          z-index: 10;
          cursor: pointer;
          position: absolute;
          top: 80px;
          background: #303030;
          font-weight: normal;
          box-shadow: 0px 3px 16px 5px rgba(0, 0, 0, 0.26);
          border-radius: 4px;
          font-size: 16px;
          line-height: 44px;
          display: none;
          opacity: 0;
          color: #c2c2c2;
          @include phone(
            (
              top: 48,
            )
          );
        }
        &:hover {
          .meau-list {
            opacity: 1;
            display: block;
          }
        }
      }
      .svgLogo {
        @include ipad(
          (
            width: 100,
          )
        );
        @include phone(
          (
            width: 100,
          )
        );
      }
    }
    &-right {
      display: flex;
      &-button {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        padding: 10px;
        margin-right: 16px;
        cursor: pointer;
        @include ipad(
          (
            padding: 7,
            width: 32,
            height: 32,
          )
        );
        @include phone(
          (
            padding: 7,
            width: 32,
            height: 32,
          )
        );
        &:last-of-type {
          margin-right: 0;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
      }
      .sidebar-logo {
        font-size: 28px;
        @include ipad(
          (
            font-size: 18,
          )
        );
        @include phone(
          (
            font-size: 18,
          )
        );
      }
    }
  }

  .banner {
    position: relative;

    background-size: cover;
    background-position-x: center;
    /deep/ .swiper-container {
      height: 100%;
    }
    /deep/ .swiper-slide {
      background-size: cover;
      background-position-x: center;
    }
    /deep/ .swiper-pagination {
      bottom: 76px;
      @include ipad(
        (
          bottom: 34,
        )
      );
      &-bullet {
      }
    }

    .loop-essay-button {
      cursor: pointer;
    }

    @media screen and(min-width: 1024px) and (max-width: 1920px) {
      background-image: url("@/assets/banner-1920-01.jpg");

      height: 700px;
      .loop-body {
        width: 63%;
        margin: 0 auto;
        > img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          display: block;
          z-index: -1;
        }
        .loop-essay {
          padding-top: 137px;
          &-title {
            font-size: 40px;
            color: #ffd591;
          }
          &-content {
            font-weight: 500;
            font-size: 24px;
            line-height: 34px;
            color: rgba(255, 255, 255, 0.75);
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            margin: 43px 0 67px 0;
          }
          &-button {
            width: 310px;
            height: 80px;
            font-size: 24px;
            text-align: center;
            line-height: 80px;
            background: linear-gradient(135deg, #e6d3a4 0%, #c9a86b 100%);
            border-radius: 4px;
            > span {
              margin-left: 14px;
            }
          }
        }
      }
    }
    @media screen and(min-width: 786px) and (max-width: 1024px) {
      background-image: url("@/assets/banner-1024-01.jpg");

      height: 700px;
      .loop-body {
        width: 90%;
        margin: 0 auto;
        .loop-essay {
          padding-top: 137px;
          &-title {
            font-size: 34px;
            color: #ffd591;
          }
          &-content {
            font-weight: 500;
            font-size: 24px;
            line-height: 34px;
            color: rgba(255, 255, 255, 0.75);
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            margin: 43px 0 67px 0;
          }
          &-button {
            width: 390px;
            height: 80px;
            left: 360px;
            font-size: 24px;
            text-align: center;
            line-height: 80px;
            background: linear-gradient(135deg, #e6d3a4 0%, #c9a86b 100%);
            border-radius: 4px;
            > span {
              margin-left: 14px;
            }
          }
        }
      }
    }
    @media screen and(min-width: 375px) and (max-width: 786px) {
      background-image: url("@/assets/banner-768-01.jpg");

      height: 700px;
      text-align: center;
      background-color: linear-gradient(360deg, #1d1d1d -6.99%, rgba(29, 29, 29, 0) 39.51%);
      .loop-body {
        width: 90%;
        margin: 0 auto;
        .loop-essay {
          padding-top: pxToVWForMiddle(267);
          &-title {
            font-size: 34px;
            color: #ffd591;
          }
          &-content {
            font-weight: 500;
            font-size: 24px;
            line-height: 34px;
            color: rgba(255, 255, 255, 0.75);
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            margin: 20px 0 49px 0;
          }
          &-button {
            width: 310px;
            height: 80px;
            margin: 0 auto;
            font-size: 24px;
            text-align: center;
            line-height: 80px;
            background: linear-gradient(135deg, #e6d3a4 0%, #c9a86b 100%);
            border-radius: 4px;
            > span {
              margin-left: 14px;
            }
          }
        }
      }
    }
    @media screen and (max-width: 375px) {
      height: 590px;
      text-align: center;
      background-color: linear-gradient(360deg, #1d1d1d -6.99%, rgba(29, 29, 29, 0) 39.51%);
      background-image: url("@/assets/banner-375-01.jpg");
      .loop-body {
        width: 90%;
        margin: 0 auto;
        .loop-essay {
          padding-top: pxToVWForSmall(247);
          &-title {
            font-size: 36px;
            line-height: 38px;
            color: #ffd591;
          }
          &-content {
            font-weight: 500;
            font-size: 15px;
            line-height: 21px;
            color: rgba(255, 255, 255, 0.75);
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            margin: 18px 0 36px 0;
          }
          &-button {
            min-width: 302px;
            height: 58px;
            margin: 0 auto;
            font-size: 20px;
            text-align: center;
            line-height: 58px;
            background: linear-gradient(135deg, #e6d3a4 0%, #c9a86b 100%);
            border-radius: 4px;
            > span {
              margin-left: 14px;
            }
          }
        }
      }
    }
  }

  // 中间部分
  .main {
    padding: 52px 0;
    background: #1d1d1d;
    overflow: hidden;
    @include phone(
      (
        padding: 27px 0 48px 0,
      )
    );
    &-title {
      text-align: center;
      font-weight: 400;
      font-size: 36px;
      line-height: 45px;
      text-transform: uppercase;
      color: #ffd591;
      margin-bottom: 35px;
      @include phone(
        (
          font-size: 20,
          line-height: 25,
        )
      );
    }
    // &-news {
    //   margin: 0 auto 35px auto;
    //   max-width: 1231px;
    //   width: 65%;
    //   display: flex;
    //   @media screen and (max-width: 1440px) {
    //     width: 90%;
    //   }
    //   @include phone(
    //     (
    //       display: block,
    //     )
    //   );
    //   &-img {
    //     width: 45%;
    //     @include ipad(
    //       (
    //         width: 389,
    //       )
    //     );
    //     @include phone(
    //       (
    //         width: 100%,
    //       )
    //     );
    //     img {
    //       width: 100%;
    //     }
    //   }
    //   &-essay {
    //     padding: 41px 55px;
    //     flex: 1;
    //     font-weight: 600;
    //     font-size: 24px;
    //     line-height: 34px;
    //     color: #d8d8d8;
    //     background: #303030;
    //     @include ipad(
    //       (
    //         padding: 18px 30px,
    //         font-size: 18,
    //         line-height: 25,
    //       )
    //     );
    //     @include phone(
    //       (
    //         padding: 18,
    //         font-size: 18,
    //         line-height: 25,
    //         text-align: center,
    //       )
    //     );
    //   }
    // }

    &-loop {
      // width: 65%;
      width: 65%;
      margin: 0 auto;
      // overflow: visible;
      &-out-1 {
        overflow-y: visible;
      }
      &-out-2 {
        overflow-x: hidden;
        overflow-y: visible;
        padding: 500px 0;
        margin: -500px 0;
      }
      // transform: scale(1.19);
      /deep/ .swiper-slide {
        // transform: scale(0.8);
        width: 33.33% !important;
        transition: 300ms;
      }
      /deep/ .swiper-slide-prev {
        // transform: scale(0.8) translateX(70px);
      }
      /deep/ .swiper-slide-next {
        // transform: scale(0.8) translateX(-70px);
      }
      /deep/ .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1.2);
        z-index: 998;
      }
      /deep/.swiper-container {
        width: 100%;
        overflow: visible;
        // overflow-x: hidden;
        // overflow-y: unset;
      }

      /deep/ .swiper-pagination {
        // bottom: 76px;
        position: relative;
        width: 100%;
        margin-top: 33px;
        @include ipad(
          (
            margin-top: 18,
          )
        );
        &-bullet {
          margin-right: 16px;
          @include ipad(
            (
              margin-right: 9,
            )
          );
          &:last-of-type {
            margin-left: 0;
          }
        }
      }
      .loop-body {
        // width: 473.55px;
        margin: 40px 0;
        position: relative;
        img {
          width: 100%;
        }
        &-tips {
          font-style: 20px;
          position: absolute;
          left: 23px;
          bottom: 20px;
          color: #ffffff;
        }
      }

      @media screen and (max-width: 1440px) {
        width: 90%;
      }
    }

    @media screen and(max-width: 450px) {
      &-loop {
        width: 270%;
        // width: 65%;
        // max-width: 1231px;
        &-out-2 {
          padding: 0;
          margin: 0;
        }
        margin: 0 auto;
        position: relative;
        left: 50%;
        margin-left: -135%;
        // transform: scale(1.15);
        /deep/ .swiper-slide {
          // width: 90% !important;
          transition: 300ms;
        }
        /deep/ .swiper-slide-prev {
          transform: scale(0.9) translate(10%);
        }
        /deep/ .swiper-slide-next {
          transform: scale(0.9) translate(-10%);
        }
        /deep/ .swiper-slide-active,
        .swiper-slide-duplicate-active {
          transform: scale(1);
          z-index: 998;
        }
        /deep/.swiper-container {
          width: 100%;
        }
        .loop-body {
          // width: 473.55px;
          margin: 0;
          img {
            width: 100%;
          }
        }
      }
    }
  }

  // 底部包含表单部分
  // .main-bottom {
  //   .shake {
  //     animation: shake 800ms ease-in-out;
  //   }
  //   background: url("@/assets/img_bg3-min.png");
  //   background-size: cover;
  //   box-sizing: border-box;
  //   padding: 137px 0 202px 0;
  //   @include ipad(
  //     (
  //       text-align: center,
  //       padding: 32px 39px,
  //     )
  //   );
  //   @include phone(
  //     (
  //       padding: 34px 17px 20px,
  //     )
  //   );
  //   .main-form {
  //     @media screen and(min-width: 960px) {
  //       max-width: 1231px;
  //       display: flex;
  //       justify-content: space-between;
  //     }
  //     margin: 0 auto;
  //     &-essay {
  //       position: relative;
  //       @media screen and(min-width: 960px) {
  //         height: 438px;
  //         width: 52%;
  //       }
  //       &-title {
  //         font-style: normal;
  //         font-weight: 400;
  //         font-size: 48px;
  //         line-height: 64px;
  //         width: 100%;
  //         text-transform: uppercase;
  //         position: relative;
  //         color: #ffffff;
  //         @include ipad(
  //           (
  //             font-size: 36,
  //             line-height: 64,
  //           )
  //         );
  //         @include phone(
  //           (
  //             font-size: 24,
  //             line-height: 36,
  //           )
  //         );
  //         &::after {
  //           content: " ";
  //           position: absolute;
  //           width: 216px;
  //           height: 4px;
  //           background: #ffd591;
  //           bottom: -19px;
  //           left: 0;
  //           @include ipad(
  //             (
  //               bottom: -10px,
  //               left: 50%,
  //               margin-left: -108px,
  //             )
  //           );
  //         }
  //       }
  //       &-content {
  //         width: 100%;
  //         font-style: normal;
  //         font-weight: 600;
  //         font-size: 24px;
  //         line-height: 34px;
  //         color: #ffffff;
  //         margin-top: 74px;
  //         @include ipad(
  //           (
  //             margin: 50px 0 32px,
  //           )
  //         );
  //         @include phone(
  //           (
  //             font-size: 14,
  //             line-height: 20,
  //           )
  //         );
  //       }
  //       &-tips {
  //         font-style: normal;
  //         font-weight: 400;
  //         font-size: 20px;
  //         line-height: 25px;
  //         color: #ffffff;
  //         @media screen and(min-width: 960px) {
  //           position: absolute;
  //           left: 0;
  //           bottom: 0;
  //         }
  //         @include ipad(
  //           (
  //             font-size: 24,
  //             line-height: 30,
  //             margin-bottom: 40,
  //           )
  //         );
  //       }
  //     }
  //     &-content {
  //       @media screen and(min-width: 960px) {
  //         width: 45%;
  //       }
  //       background: #ffffff;
  //       padding: 31px 51px;
  //       text-align: center;
  //       box-sizing: border-box;
  //       @include phone(
  //         (
  //           padding: 30px 20px 34px,
  //         )
  //       );
  //       &-title {
  //         margin-bottom: 30px;
  //         font-weight: 400;
  //         font-size: 24px;
  //         line-height: 29px;
  //         color: #000000;
  //         @include phone(
  //           (
  //             font-size: 16px,
  //           )
  //         );
  //       }
  //       &-tips {
  //         margin-bottom: 49px;
  //         font-weight: 400;
  //         font-size: 18px;
  //         line-height: 22px;
  //         color: #000000;
  //         @include phone(
  //           (
  //             font-size: 12,
  //             margin-bottom: 38,
  //           )
  //         );
  //       }
  //       &-input {
  //         margin-bottom: 32px;
  //         /deep/ .input-box {
  //           background: #e6e6e6;
  //           @include ipad(
  //             (
  //               height: 50px,
  //             )
  //           );
  //           input {
  //             color: #000000;
  //           }
  //         }
  //         input {
  //           width: 100%;
  //           border: none;
  //           background: #e6e6e6;
  //           line-height: 50px;
  //           font-size: 18px;
  //           box-sizing: border-box;
  //           text-indent: 1em;

  //           @include phone(
  //             (
  //               line-height: 36px,
  //             )
  //           );
  //         }

  //         @include phone(
  //           (
  //             margin-bottom: 24,
  //           )
  //         );
  //       }
  //       &-button {
  //         button {
  //           line-height: 60px;
  //           @include ipad(
  //             (
  //               line-height: 60,
  //             )
  //           );
  //           @include phone(
  //             (
  //               line-height: 45,
  //             )
  //           );
  //           background: linear-gradient(135deg, #d3be8c 0%, #c2a061 100%);
  //           color: #000000;
  //           width: 100%;
  //           border: none;
  //           cursor: pointer;
  //           font-weight: 600;
  //           font-size: 18px;
  //         }
  //       }
  //     }
  //   }
  // }

  .footer {
    background: #282828;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;

    @include phone(
      (
        height: 38,
      )
    );
    .tips {
      margin-left: 43px;
      align-items: center;
      color: #999999;
      @include phone(
        (
          margin-left: 20,
          font-size: 12,
        )
      );
    }
    .svgLogo {
      @include phone(
        (
          width: 100,
        )
      );
    }
  }

  /deep/ .swiper-pagination {
    width: 100%;
    &-bullet {
      width: 32px;
      height: 12px;
      background: #d9d9d9;
      opacity: 0.35;
      border-radius: 120px;
      transition: opacity 1s;

      @include ipad(
        (
          width: 16,
          height: 6,
        )
      );
    }

    &-bullet-active {
      background: #ffffff;
      opacity: 1;
    }
  }
}

.hide-1024 {
  display: none;
  @media screen and (min-width: 1024px) and (max-width: 1920px) {
    display: block;
  }
}
.hide-768 {
  display: none;
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    display: block;
  }
}
.hide-375 {
  display: none;
  @media screen and (min-width: 375px) and (max-width: 768px) {
    display: block;
  }
}
</style>
